import { brandPrimary } from "@av/config/antdRootTheme";

import type { ThemeConfig } from "antd";

export const platformTheme: ThemeConfig = {
  token: {
    colorPrimary: brandPrimary,
    colorPrimaryBg: "#E3EAFB",
    colorInfoBg: "#E3EAFB",
    colorInfoBorder: "#A0BDFF",
  },
};
